import { SelectOptionValue } from 'dashboard/components-lib/MultiSelect/MultiSelect';
import { GOVERNMENT_ID_DISPLAY_STRINGS, GovernmentIdClass } from 'lib/constants/governmentIds';
import { COUNTRIES } from 'lib/constants/locales';

const COUNTRY_CODES: SelectOptionValue<string>[] = Object.keys(COUNTRIES).map((key) => {
  return {
    label: key,
    value: key,
  };
});

const ID_OPTIONS: SelectOptionValue<string>[] = Object.keys(GOVERNMENT_ID_DISPLAY_STRINGS).map(
  (key) => ({
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    label: GOVERNMENT_ID_DISPLAY_STRINGS[key as GovernmentIdClass],
    value: key,
  }),
);

export const VERIFICATION_VALUES_OPTIONS: Record<string, SelectOptionValue<string>[]> = {
  country_code: COUNTRY_CODES,
  capture_method: [
    {
      label: 'API',
      value: 'api',
    },
    {
      label: 'Auto',
      value: 'auto',
    },
    {
      label: 'Combo',
      value: 'combo',
    },
    {
      label: 'Manual',
      value: 'manual',
    },
    {
      label: 'Upload',
      value: 'upload',
    },
  ],

  platform: [
    { label: 'Android', value: 'Android' },
    { label: 'API', value: 'API' },
    { label: 'iOS', value: 'iOS' },
    { label: 'Web', value: 'Web' },
  ],
  issuing_country: COUNTRY_CODES,
  country_select: COUNTRY_CODES,
  selected_id_type: ID_OPTIONS,
  id_type: ID_OPTIONS,
  device_group: [
    {
      label: 'Desktop',
      value: 'Desktop',
    },
    {
      label: 'Mobile',
      value: 'Mobile',
    },
    { label: 'Other', value: 'Other' },
    {
      label: 'Unknown',
      value: 'Unknown',
    },
  ],
};
